module.exports = __webpack_public_path__ + "static/img/hover-iocn54.d4f2901.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/add_icon/hover-iocn54.png
// module id = 9gdk
// module chunks = 1